import { css } from '@emotion/react';
import { theme } from '../../domain/theme';

export const consentMgmt = css`
  width: 100%;
  position: relative;
  background: #000;
  padding-top: 32px;
  min-height: 800px;

  & a {
    color: #fff;
  }

  & .error {
    color: #fc4349;
  }

  & .completed {
    color: #fc0;
  }

  ${theme.mq.tablet} {
    & .consent-mgmt__input-text .consent-mgmt__text-input {
      width: 360px;
    }
  }
`;

export const consentMgmtCheckbox = css`
  display: inline;
  position: relative;
  float: left;
  clear: both;

  & input[type='checkbox'] {
    display: none;
    line-height: 1.125rem;
  }

  & input[type='checkbox']:checked + label span {
    color: #fc0;
  }

  & input[type='checkbox'] + label span {
    background: 0 0;
    content: '';
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 1px solid #787878;
    cursor: pointer;
  }

  & input[type='checkbox'] + label span:before {
    position: absolute;
    top: 0;
    left: 2px;
  }

  & input[type='checkbox'] + label span.border-error {
    border-color: #fc4349;
  }

  ${theme.mq.tablet} {
    & {
      display: block;
      float: left;
      margin-left: 0;
      min-width: inherit;
      max-width: inherit;
    }

    & input[type='checkbox'] {
      display: none;
    }
  }

  & input[type='checkbox']:checked + label span {
    background: url('data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZjMDt9PC9zdHlsZT48L2RlZnM+CjxwYXRoIGNsYXNzPSJjbHMtMSIgIHRyYW5zZm9ybT0ic2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgwLCAtOTYwKSIgdW5pY29kZT0iJiN4NDk7IiBnbHlwaC1uYW1lPSJ2LXRpY2siIGQ9Ik03NDEuMiA3MjdsLTMwNS01MDYuOC0yNjAuOCAxNTctMzUuMi01OC40IDI4Ni0xNzIgMzIuOC0yMC44IDM0MC42IDU2NS44eiIgLz4KPC9zdmc+')
      no-repeat center center;
  }
`;

export const consentMgmtContents = css`
  color: #fff;
  text-align: center;
  overflow: hidden;
  padding: 0 30px 100px 30px;

  & h5 {
    ${theme.font.family('regularWeb')};
    font-weight: 400;
    letter-spacing: 2.5px;
    line-height: 1.5;
    font-style: normal;
    font-weight: 400;
    color: #787878;
    font-size: 0.875rem;
    margin: 0;
    text-transform: uppercase;
  }

  & h3 {
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    font-size: 1.25rem;
    letter-spacing: 2.5px;
    line-height: 1.5;
    margin-top: 5px;
    text-transform: uppercase;
  }

  & p {
    ${theme.font.family('regularWeb')};
    font-weight: 400;
    letter-spacing: 0.04em;
    font-size: 0.9375rem;
    line-height: 1.375rem;
  }

  & button {
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    letter-spacing: 3px;
    line-height: 1.5;
    font-style: normal;
    background: #333;
    border: none;
    color: #fff;
    display: block;
    height: 50px;
    min-width: 315px;
    max-width: 380px;
    margin: 0 auto 25px;
    width: 100%;
    text-transform: uppercase;
  }

  & h6 {
    ${theme.font.family('regularWeb')};
    font-weight: 400;
    letter-spacing: 0.04em;
    font-size: 1rem;
    line-height: 1.375rem;
    margin: 25px auto;
  }

  & h7 {
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    font-size: 0.75rem;
    letter-spacing: 2.5px;
    line-height: 1.5;
    color: #787878;
    float: left;
    margin-left: 10px;
    text-transform: uppercase;
    text-align: left;
    width: 90%;
  }

  & h7 strong {
    color: #fff;
  }

  & .consent-mgmt__input {
    margin-left: 20px;
  }

  & .consent-mgmt__input-text {
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    font-size: 0.75rem;
    letter-spacing: 2.5px;
    line-height: 1.5;
    color: #787878;
    float: left;
    text-align: left;
    width: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
    clear: both;
    text-transform: uppercase;
  }

  & .consent-mgmt__input-text .consent-mgmt__text-input {
    min-width: 315px;
    max-width: 380px;
    width: 100%;
    padding: 8px;
    text-align: center;
    display: inline-block;
    float: left;
    border-radius: 0;
    text-transform: uppercase;
    border: none;
    outline: 0;
  }

  ${theme.mq.tablet} {
    & {
      width: 525px;
      margin: 0 auto;
    }

    & button {
      display: inline-block;
      width: 160px;
      border-radius: 0;
      min-width: inherit;
      max-width: inherit;
    }

    & h7 {
      float: left;
      text-align: left;
      margin-left: 10px;
      width: 93%;
    }

    & h3 {
      font-size: 1.875rem;
      line-height: 2.25rem;
      margin: 15px 0 25px;
    }

    & h5 {
      font-size: 0.9375rem;
    }

    & p {
      font-size: 1rem;
    }

    & .consent-mgmt__input {
      margin-left: 0;
    }
  }

  ${theme.mq.small_desktop} {
    & h7:hover {
      color: #fff;
      cursor: pointer;
    }

    & h7:hover span {
      border-color: #fff;
    }
  }
`;

export const consentMgmtEmailBox = css`
  ${theme.font.family('boldWeb')};
  font-weight: 400;
  letter-spacing: 3px;
  line-height: 1.5;
  font-style: normal;
  border: none;
  outline: 0;
  width: 305px;
  height: 49px;
  margin: 30px 0 15px;
  text-align: left;
  text-indent: 15px;
  text-transform: uppercase;
  border-radius: 0;

  ${theme.mq.tablet} {
    & {
      margin-top: 55px;
    }
  }
`;

export const consentMgmtErrorMessage = css`
  color: #fc4349;
  padding-top: 50px;
  text-align: left;
  text-transform: uppercase;

  & span {
    display: none;
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    letter-spacing: 3px;
    line-height: 1.5;
    font-style: normal;
    font-size: 0.625rem;
    margin-bottom: 20px;
    clear: both;
  }

  ${theme.mq.tablet} {
    & {
      margin-left: 0;
    }
  }
`;

export const consentMgmtImageOne = css`
  display: none;

  ${theme.mq.small_desktop} {
    & {
      height: 183px;
      width: 276px;
    }

    & {
      margin-left: 50px;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      max-width: 300px;
      height: 300px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      top: 50px;
      left: 30px;
      width: 345px;
      height: 345px;
    }
  }
`;

export const consentMgmtImageTwo = css`
  display: none;

  ${theme.mq.small_desktop} {
    & {
      height: 183px;
      width: 276px;
    }

    & {
      display: block;
      position: absolute;
      bottom: 50%;
      right: 0;
      max-width: 300px;
      height: 200px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      height: 200px;
      width: 345px;
    }
  }
`;

export const consentMgmtLoadingImage = css`
  ${theme.mq.tablet} {
    & {
      margin-top: 55px;
    }
  }
`;

export const consentMgmtPhotoCredit = css`
  display: none;

  ${theme.mq.small_desktop} {
    & {
      display: block;
      ${theme.font.family('boldWeb')};
      font-weight: 400;
      letter-spacing: 3px;
      line-height: 1.5;
      font-style: normal;
      color: #787878;
      bottom: 23px;
      font-size: 0.75rem;
      position: absolute;
      left: 50%;
      text-transform: uppercase;
      transform: translateX(-50%);
    }
  }
`;

export const consentMgmtSuccessText = css`
  color: #787878;
`;

export const consentMgmtTerms = css`
  display: inline;
  border-bottom: 1px solid #787878;
  line-height: 0.75rem;
`;
